<template>
    <div class="search-result">
        <div class="search-detail">
            <h3>
                <span>搜索结果</span><p>搜索到平台官方规则&nbsp;<span>{{searchTitle.count || searchList.count || 0}}</span>&nbsp;条：</p>
            </h3>
            <div v-if="searchTitle.count || searchList.count">
                <ul v-if="searchTitle.data">
                    <li v-for="(item,index) in searchTitle.data" :key="index">
                        <div class="title" @click="toDetail(item)" v-html="item.title"></div>
                    </li>
                </ul>
                <ul v-if="searchList.data">
                    <li v-for="(item,index) in searchList.data" :key="index">
                        <div class="title titleS" @click="toDetail(item)" v-html="item.title"></div>
                        <div class="content" v-html="item.content"></div>
                    </li>
                </ul>
                <div class="pagination" >
                    <a-pagination 
                        :total="searchTitle.count || searchList.count" 
                        :itemRender="itemRender" 
                        @change="onChange" 
                        :current="current"
                        :pageSize="pagesize"
                    />  
                </div>
            </div>
            <div v-else>
                <ul>
                    <li>
                       <div class="content">很抱歉，没有搜索到与“<span style="color:#f70">{{$route.query.searchword || sidercodeToName}}</span>”相关的规则，要不您换个关键词我再帮您找找看。</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import {Pagination} from 'ant-design-vue'
import { mapState } from 'vuex'
import {$tracker} from '@utils'
import Bus from '@utils/bus'
export default {
    components:{'a-pagination':Pagination},
    beforeCreate(){
        const param = {
            ...this.$route.query,
            current: 1,
            pagesize: 10
        }
        this.$store.dispatch('toSearchByQuery',param);
    },
    watch: {
        $route(to, from) {
            this.current = 1
            this.pagesize = 10
        }
    },
    computed:{
        ...mapState([
            'searchword',
            'searchList',
            'sidercode',
            'searchTitle',
            'menus'
        ]),
        sidercodeToName(){
            const sidercode = this.$route.query.sidercode;
            let siderTitle = '';
            this.menus.forEach(item =>{
                if(item.id == sidercode){
                    siderTitle=  item.title
                } else {
                    item.children.forEach(o =>{
                        if(o.id == sidercode){
                            siderTitle = o.title
                        }
                    })
                }
            })
            return siderTitle || this.$route.query.sidercode
        }
    },
    data() {
        return {
            current: 1,
            pagesize: 10,
        }
    },
    created(){
        $tracker('288950',10000)
        Bus.$on('initSearchParams',()=>{
            this.current = 1;
        })
    },
    methods:{
        itemRender(current, type, originalElement) {
            if (type === 'prev') {
            return <a class="pagePN"><span class="triangleLeft"></span>上一页</a>;
            } else if (type === 'next') {
            return <a class="pagePN">下一页<span class="triangleRight"></span></a>;
            }
            return originalElement;
        },
        toDetail(item){
            const routeData = this.$router.push({name:'detail',query:{id:item.id}})
            // window.open(routeData.href, '_blank');
        },
        onChange(current, pagesize) {
            this.current = current
            this.pagesize = pagesize
            const param = {
                ...this.$route.query,
                current: current,
                pagesize: pagesize
            }
            this.$store.dispatch('toSearchByQuery',param); 
        },
    }
}
</script>
<style lang="scss">
$size-normal: 14px;
$color-primary: #1C7AE5;
$color-text-secondary: #999999;
$color-text-primary: #333333;
.search-result {
 // antd pagination  分页样式
    .ant-pagination  {
        // width: 100%;
        // display: flex;
        float: right;
        padding-right: 20px;

        .ant-pagination-total-text {
            order: -2;
            font-size: $size-normal;
            color: $color-text-primary;
            letter-spacing: 0;  
        }

        .ant-pagination-prev,
        .ant-pagination-next {
            background: #FFFFFF;
            border: 1px solid #DBDBDB ;
            width: 64px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
            color: #CCCCCC;
            letter-spacing: 0;
            text-align: center;
            border: 1px solid #ccc;
            border-radius: 0; 
            margin-right: 10px;
        }

        .ant-pagination-item  {
            background: #FFFFFF;
            border: 1px solid #DBDBDB;
            height: 28px;
            line-height: 28px;
            color: $color-text-secondary;
            letter-spacing: 0;
            font-size: $size-normal;
            letter-spacing: 0;
            text-align: center;
            border-radius: 0;
            margin-right: 5px;
            text-align: center;
        }

        .ant-pagination-item-active {
            // background: $color-primary;
            font-size: $size-normal;
            letter-spacing: 0;
            text-align: center;
            border: 0;
            border: 1px solid $color-primary;

            // a {
            //     color: #FFF;
            // }
        }

        .ant-pagination-options {
            order: -1;
            border-radius: 0;
            flex: 1;

            .ant-select-selection {
                border-radius: 0;
            }
        }

        .ant-pagination-disabled  {
            .pagePN:hover {
                .triangleLeft {
                    border-right: 5px solid #cccccc !important;
                }

                .triangleRight {
                    border-left: 5px solid #cccccc !important;
                }
            }
        }

        .pagePN:hover {
            .triangleLeft {
                border-right: 5px solid $color-primary !important;
            }

            .triangleRight {
                border-left: 5px solid $color-primary !important;
            }
        }

        .triangleLeft {
            margin-right: 4px;
            display: inline-block;
            position: relative;
            width: 0;
            height: 0;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-right: 5px solid #cccccc;
        }

        .triangleRight {
            margin-left: 4px;
            display: inline-block;
            position: relative;
            width: 0;
            height: 0;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 5px solid #cccccc;
        }

        .ant-pagination-options-quick-jumper {
            input {
                border-radius: 0;
                height: 28px;
            }
        }
    }

}

</style>
<style lang="scss" scoped>
 .search-result {
    padding-bottom: 15px;
    text-align: left;
    .search-detail {
        @include mHCMain;
        background-color: #fff;
        padding: 20px;
        >h3 {
            position: relative;
            display: flex;
            padding-left: 8px;
            align-items: center;
            >span {
                font-size: 16px;
                color: #333333;
                padding-right: 10px;
            }
            >p {
                font-size: 14px;
                color: #666666;
                span {
                    color: #FF3A00;
                }
            }
            &::before {
                content: "";
                position: absolute;
                left: 0;
                height: 12px;
                top: 50%;
                transform: translateY(-50%);
                width: 3px;
                background: #1C7AE5;
            }
        }
        ul {
            margin-top: 9px;
            li {
                padding: 20px 14px;
                border-bottom: 1px dashed #EEEEEE;
                .title {
                    line-height: 20px;
                    position: relative;
                    cursor: pointer;
                    &:hover {
                        color: #116CD0;
                    }
                    &:before {
                        content: "";
                        position: absolute;
                        left: -14px;
                        top: 50%;
                        width: 4px;
                        height: 4px;
                        background: #DDDDDD;
                        border-radius: 4px;
                        transform: translateY(-50%);
                    }
                }

                .titleS {
                    color: #116CD0;
                }

                .titleS /deep/ b {
                    color: #FF3A00;
                } 

                .content {
                    font-size: 13px;
                    color: #666666;
                    padding-top: 9px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    height: 28px;   
                }
                .content /deep/ b {
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    color: #FF3A00;
                }   
                .content /deep/ p {
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                }  
                .content /deep/ img {
                    display: none;
                }  
            }
        }
        .pagination {
            padding-top: 11px;
            height: 60px;
        }
     }
 }
</style>


